(() => {
  const roots = document.querySelectorAll('[data-bn-final-page]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const vote = root.querySelector('[data-bn-vote]');
    if (vote) {
      const button = vote.querySelector('[data-bn-vote-submit]');
      const status = vote.querySelector('[data-bn-vote-status]');
      const radios = vote.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (button) button.disabled = false;
          if (status) status.textContent = `WYBRANO: ${radio.dataset.label || radio.value}.`;
        });
      });
      const saveVote = (event) => {
        event.preventDefault();
        const selected = vote.querySelector('input[type="radio"]:checked');
        if (!selected || !status) return;
        status.textContent = `WYBÓR „${selected.dataset.label || selected.value}” ZAPISANY W PODGLĄDZIE. PRZED PUBLIKACJĄ MODUŁ ZOSTANIE PODŁĄCZONY DO AKTYWNEGO GŁOSOWANIA.`;
        status.setAttribute('tabindex', '-1');
        status.focus({ preventScroll: true });
        if (button) {
          button.textContent = 'WYBÓR ZAPISANY';
          button.disabled = true;
        }
      };
      vote.addEventListener('submit', saveVote);
      if (button) button.addEventListener('click', saveVote);
    }

    const revealNodes = root.querySelectorAll('[data-bn-reveal]');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      revealNodes.forEach((node) => observer.observe(node));
    } else {
      revealNodes.forEach((node) => node.classList.add('is-visible'));
    }

    root.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        const id = anchor.getAttribute('href');
        if (!id || id === '#') return;
        const target = root.querySelector(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
  });
})();
